import { Dispatch } from "redux";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { findRoute } from "src/store/dataService/routes/util";
import {
    getMessagesFailure,
    getMessagesRequest,
    getMessagesSuccess,
    postMessageFailure,
    postMessageRequest,
    postMessageSuccess,
} from "src/store/actions/messages";
import { getFromAuthed, postTo } from "src/store/dataService/routes/shared/osfetch";

const postMessage = async (next: Dispatch, { payload: { message, uuid } }: ActionType<typeof postMessageRequest>) => {
    try {
        const response = await postTo(`/deals/${uuid}/messages`, { message }, next, false);

        if (!response.ok) {
            throw new Error();
        }

        const { sent } = await response.json();

        next(postMessageSuccess(message, sent));
    } catch (e) {
        next(postMessageFailure(message));
    }
};

const getMessages = async (next: Dispatch, { payload: { uuid } }: ActionType<typeof getMessagesRequest>) => {
    try {
        const response = await getFromAuthed(`/deals/${uuid}/messages`, next, true);

        if (!response.ok) {
            throw new Error();
        }

        const data = await response.json();

        next(getMessagesSuccess(data));
    } catch (e) {
        next(getMessagesFailure());
    }
};

export const routes = {
    [postMessageRequest.type]: postMessage,
    [getMessagesRequest.type]: getMessages,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
